import script from "./Roles.vue?vue&type=script&setup=true&lang=js"
export * from "./Roles.vue?vue&type=script&setup=true&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=0e9b813e&scoped=true&lang=css"
import "./Roles.vue?vue&type=style&index=1&id=0e9b813e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e9b813e"]])

export default __exports__